// Kleiner Vermittler, damit WALTER das (bereits geladene) Userback-Widget mit einer
// vorformulierten Frage öffnen kann. Der öffentliche Widget-SDK erlaubt kein direktes
// Vorbefüllen des Textfelds, daher: Frage als Metadaten anhängen (setData) + in die
// Zwischenablage kopieren, dann das Feedback-Formular öffnen.
let instance = null;

export const registerUserback = (ub) => {
  instance = ub;
};

export const isUserbackReady = () => !!instance;

export const openUserbackWithQuestion = async (question, meta = {}) => {
  if (!instance) return false;
  try {
    if (typeof instance.setData === "function") {
      instance.setData({ walter_frage: question || "", ...meta });
    }
    try {
      if (question && navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(question);
      }
    } catch {
      /* clipboard nicht verfügbar – kein Blocker */
    }
    if (typeof instance.open === "function") instance.open("general");
    else if (typeof instance.show === "function") instance.show();
    return true;
  } catch {
    return false;
  }
};
